import { isConfigEnabled, INVENTORY_OUTBOUND_FIFO_PARAM } from '../api/sys/param'

/** 出库是否按先进先出（inventory-outbound-fifo=1 时禁用手工选出库库位） */
export default {
  data() {
    return {
      outboundFifoEnabled: false
    }
  },
  methods: {
    loadOutboundFifoPolicy() {
      return isConfigEnabled(INVENTORY_OUTBOUND_FIFO_PARAM).then(enabled => {
        this.outboundFifoEnabled = enabled
        return enabled
      })
    },
    isFormReadonlyForOutbound() {
      if (typeof this.formReadonly !== 'undefined') return !!this.formReadonly
      if (typeof this.formDisabled === 'function') return !!this.formDisabled()
      if (typeof this.formDisabled !== 'undefined') return !!this.formDisabled
      return !!this.readonly
    },
    isOutboundWarehouseSelectDisabled() {
      return this.isFormReadonlyForOutbound() || this.outboundFifoEnabled
    },
    clearOutboundLineWarehouses(lines, field = 'wareHouseId') {
      if (!this.outboundFifoEnabled || this.isFormReadonlyForOutbound()) return
      ;(lines || []).forEach(row => { row[field] = '' })
    }
  }
}
